<template>
  <BaseTypography :as="as" :class="fontSize" class="font-medium">
    <slot></slot>
  </BaseTypography>
</template>

<script setup>
import BaseTypography from '@/components/typography/base.vue'
import { computed } from 'vue'

const props = defineProps({
  as: {
    type: String,
    default: () => 'h1'
  }
})

const fontSize = computed(() => {
  switch (props.as) {
    case 'h1':
      return 'text-3xl'
    case 'h2':
      return 'text-2xl'
    case 'h3':
      return 'text-xl'

    default:
      return 'text-base'
  }
})
</script>

<style lang="scss" scoped></style>
